import type { ImageDto } from '@klickibunti/pagebuilder-react';
import type { ImageOpts } from './RenderContext';
import { ClientEnvironment } from '@/lib/env.client';

const STRAPI_BASE_URL = ClientEnvironment.NEXT_PUBLIC_STRAPI_URL;

// V1: pass-through to the Strapi media URL, picking a named format if
// requested. Full CDN topology (resize parameters, signed URLs, focal
// points) is a separate concept — concept §12 "Images, scaling, CDN
// topology". Keeping the seam here so it can grow without touching
// every widget.
export function buildImageUrl(
  media: ImageDto | { url?: string } | undefined,
  opts?: ImageOpts,
): string {
  if (!media) {
    return '';
  }
  const m = media as ImageDto;
  if (opts?.format && opts.format !== 'original' && Array.isArray(m.formats)) {
    const fmt = m.formats.find((f) => f.name === opts.format);
    if (fmt?.url) {
      return absolutize(fmt.url);
    }
  }
  return absolutize(m.url ?? '');
}

function absolutize(url: string): string {
  if (!url) {
    return '';
  }
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  return `${STRAPI_BASE_URL}${url.startsWith('/') ? '' : '/'}${url}`;
}
